import type { EventBusPort } from '@ochal/module-sdk/contracts';

type Listener = (payload: never) => void | Promise<void>;
export class EventDispatchError extends Error { constructor(public readonly causes: readonly unknown[]) { super('One or more event listeners failed'); this.name = 'EventDispatchError'; } }
export class TypedEventBus<Events extends object> implements EventBusPort<Events> {
  private readonly listeners = new Map<Extract<keyof Events, string>, Set<Listener>>();
  on<K extends Extract<keyof Events, string>>(event: K, listener: (payload: Events[K]) => void | Promise<void>): () => void {
    const listeners = this.listeners.get(event) ?? new Set<Listener>();
    listeners.add(listener as Listener); this.listeners.set(event, listeners);
    return () => { listeners.delete(listener as Listener); };
  }
  async emit<K extends Extract<keyof Events, string>>(event: K, payload: Events[K]): Promise<void> {
    const results = await Promise.allSettled([...(this.listeners.get(event) ?? [])].map((listener) => Promise.resolve().then(() => listener(payload as never))));
    const causes = results.flatMap((result) => result.status === 'rejected' ? [result.reason] : []);
    if (causes.length) throw new EventDispatchError(causes);
  }
  clear(): void { this.listeners.clear(); }
}
